import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Spinner } from "components";
import i18next, { t } from "i18next";
import Form from "../components/Form";
import { useIsLoggedIn, useFocus } from "hooks";
import { UTILS } from "utils";
import {
  useVerifyPinMutation,
  useResendOtpMutation,
} from "store/auth/register/registerService";
import C from "Constants";
import { RegisterAction } from "store/actions";
import { BrandAction } from "store/actions";
import AuthHeader from "components/login/AuthHeader";
import { maskPhoneNumber, maskEmail } from "utils/Utils";

const Verification = ({ goToLogin, goToBasket, goToHomePage }) => {
  useIsLoggedIn();
  useFocus("verificationInput");

  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const [verifyPin] = useVerifyPinMutation();
  const [resendOtp] = useResendOtpMutation();
  const [isMounted, setIsMounted] = useState(false);
  const [state, setState] = useState({});
  const [seconds, setSeconds] = useState(30);
  const [verificationCode, setVerificationCode] = useState("");
  const {
    loader: { isLoading },
    NotPersist: { pageLoaded },
    cart,
    register: { error },
  } = useSelector((state) => ({
    loader: state.loader,
    NotPersist: state.NotPersist,
    AppReducer: state.AppReducer,
    cart: state?.cart,
    register: state.register,
  }));

  useEffect(() => {
    if (pageLoaded) {
      if (params?.domainName) {
        goToLogin();
      } else {
        window.history.back();
      }
    }
  }, [pageLoaded]);

  const handleChange = (value) => {
    let d = UTILS.NumberConversion(value);
    setVerificationCode(d);
  };
  const { brandInfo: brand } = useSelector(
    (state) => state?.brandStorageReducer
  );

  const verifyOtp = async () => {
    const brandId = brand?.brand?._id;
    if (verificationCode?.length === 4 && isMounted) {
      const obj = {
        ...state,
        brandId: brandId,
        verificationCode,
        language: i18next.language,
      };
      const { data } = await verifyPin(obj);
      if (data?.success === 1 && data?.data?.token) {
        dispatch(BrandAction.getDiscounts({ brandId }));
        if (cart?.cart?.length > 0) {
          goToBasket();
        } else {
          goToHomePage();
        }
        localStorage.setItem("loginEvent", Date.now().toString());
      }
    }
  };
  useEffect(() => {
    verifyOtp();
  }, [verificationCode]);

  useEffect(() => {
    if (isMounted) {
      const state = history?.location?.state;
      if ((state?.phoneNumber && state?.countryObj) || state?.email) {
        setState({
          ...state,
        });
        const element = document.getElementById("verificationInput");
        element?.focus();
      } else {
        history.goBack();
      }
    } else {
      setIsMounted(true);
    }
  }, [isMounted]);

  // Resend verification code
  const resendCode = async () => {
    if (brand?.brand?._id) {
      const obj = {
        ...state,
        brandId: brand?.brand?._id,
        userType: C.CUSTOMER,
        language: i18next.language,
      };
      const { data } = await resendOtp(obj);
      let d = data?.success === 1 ? setSeconds(30) : "";
    } else {
      dispatch(
        RegisterAction.reSendVerificationCodeFailure(
          t("Something was incorrect.")
        )
      );
    }
  };

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  });

  if (isLoading) return <Spinner />;
  return (
    <>
      <div className="store-page store-page-popup verify-page min-h-app-height my-0 p-4 bg-white">
        <AuthHeader
          goBack={goToLogin}
          description={`We send a code on your` + (state?.email ? " email" : " WhatsApp")}
          infoContent={state ? <span dir="ltr" className="l-d mx-1 text-16x leading-19x text-shadow-forge-700">
           {state?.email ? maskEmail(state?.email) : maskPhoneNumber(state?.countryObj?.dialCode, state?.phoneNumber)}
          </span> : null}
          showInfoAlongWithDescription={true}
          title="Verify your"
          blinkText={state?.email ? "Email" : "WhatsApp"}
        />
        <div className="mt-16 pt-15">
        <Form 
          {...{
            verificationCode,
            handleChange,
            seconds,
            error,
            resendCode,
          }}
        />
        </div>
        {/* <div className="mt-148x">
        <CustomButton form="verification-form" type="submit" disabled={verificationCode.length !== 4} onClick={verifyOtp}>
          <TranslationText text="Verify" />
        </CustomButton>
        </div> */}
      </div>
    </>
  );
};

export default Verification;
